// extracted by mini-css-extract-plugin
export default {"read_only_block":"ReadOnlyBanner_read_only_block__LqZYl","read_only_banner":"ReadOnlyBanner_read_only_banner__OwJXn"};